import { Button } from "@mantine/core";

import { Pickup } from "../../types/interfaces";
import { PickupStatus, CarrierType } from "../../types/enums";

type PickupHistoryProps = {
  data: Pickup[];
  abortPickup: (pickupId: string) => void;
  pickupCarrier?: CarrierType;
};

const PickupHistory = ({
  data,
  abortPickup,
  pickupCarrier,
}: PickupHistoryProps) => {
  const isPickupAbortAllowed = (pickupCarrier?: CarrierType) => {
    if (!pickupCarrier) {
      return false;
    }
    /*
     * Ciblex do not allow to abort a pickup from their API
     */
    return [CarrierType.FEDEX_TNT].includes(pickupCarrier);
  };

  if ((data ?? []).length === 0) {
    return <>No pickup available yet.</>;
  }
  return (
    <>
      {data.map((pickup: Pickup, index: number) => {
        return (
          <div key={pickup.id}>
            <div style={{ textAlign: "center", paddingBottom: "0.5rem" }}>
              Pickup {index + 1}
            </div>
            <div>
              <span style={{ fontWeight: "bold" }}>Created:</span>{" "}
              {pickup.createdAt
                ? new Date(pickup.createdAt).toLocaleString()
                : "N/A"}
            </div>
            <div>
              <span style={{ fontWeight: "bold" }}>Scheduled:</span>{" "}
              {pickup.scheduledDate
                ? new Date(pickup.scheduledDate).toLocaleString()
                : "N/A"}
            </div>
            <div>
              <span style={{ fontWeight: "bold" }}>Clinic closing time:</span>{" "}
              {pickup.closingTime || "N/A"}
            </div>
            <div>
              <span style={{ fontWeight: "bold" }}>Tracking number:</span>{" "}
              {pickup?.shipping?.trackingNumber || "N/A"}
            </div>
            <div>
              <span style={{ fontWeight: "bold" }}>Status:</span>{" "}
              {pickup.status}&nbsp;
            </div>
            {pickup.comment && (
              <div>
                <span style={{ fontWeight: "bold" }}>Comment:</span>{" "}
                {pickup.comment}&nbsp;
              </div>
            )}
            {pickup.status === PickupStatus.ACTIVE &&
              isPickupAbortAllowed(pickupCarrier) && (
                <div style={{ textAlign: "center" }}>
                  <Button
                    onClick={() => {
                      if (
                        confirm("Are you sure you want to cancel this pickup?")
                      ) {
                        abortPickup(pickup.id);
                      }
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              )}
            <hr />
          </div>
        );
      })}
    </>
  );
};

export default PickupHistory;
